export default function filterImagesForCoverImage(
  productImages,
  quality = "medium",
) {
  if (productImages) {
    const availableImages = productImages.filter(img => img !== undefined);
    if (availableImages.length > 0 && availableImages[0] !== null) {
      return availableImages[0][quality];
    }
  }

  return "";
}
